module.exports = __webpack_public_path__ + "static/media/course-catalog.3ef628f8.svg";